import React, { useCallback, useMemo } from "react";
import { Stack } from "@mui/material";
import StyledToggleButton from "./StyledToggleButton";
import StyledToggleButtonGroup from "./StyledToggleButtonGroup";
import { isValidValue } from "utils";
import { useQueryParam } from "hooks";

const ToggleButton = ({
  title,
  options = [],
  defaultValue = "active",
  keyName = "status",
  extraParams = {},
}) => {
  const [status, setStatus] = useQueryParam(keyName, defaultValue);

  const handleChange = useCallback(
    (e, newValue) => {
      if (!isValidValue(newValue)) return;
      setStatus({ [keyName]: newValue, search: null, page: 1, ...extraParams });
    },
    [setStatus, keyName, extraParams],
  );

  const renderedOptions = useMemo(() => {
    return options.map(({ value, label, icon }) => (
      <StyledToggleButton key={value} value={value}>
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            gap: 1
          }}>
          {icon || null}
          {label} {title}
        </Stack>
      </StyledToggleButton>
    ));
  }, [options, title]);

  return (
    <StyledToggleButtonGroup
      value={status}
      exclusive
      onChange={handleChange}
      sx={{ height: 40 }}
    >
      {renderedOptions}
    </StyledToggleButtonGroup>
  );
};

export default React.memo(ToggleButton);
